import { Component, OnInit } from '@angular/core';
import axios from 'axios';
import { environment } from '../../../environments/environment';
import { ToastService } from '../../services/toast.service';
import { HttpClient } from '@angular/common/http';
//import { resolveTxt, reverse } from 'dns';

@Component({
  selector: 'app-diagnostic',
  templateUrl: './diagnostic.component.html',
  styleUrls: ['./diagnostic.component.scss']
})
export class DiagnosticComponent implements OnInit {
  
  constructor(private httpClient: HttpClient) {  }

  token = window.sessionStorage.getItem('token');
  userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
  loading = false;

  connectionString  = '';
  logContents = '';

  async ngOnInit() {
    let ghh1 = '';
  }

  showConnectionString() {
    let url = environment.API_URL + '/mars/diagnostic/getconnectionstring';
    this.makeApiCallAndReturnResults(url);
  }

  showLogContents() {
    let url = environment.API_URL + '/mars/diagnostic/getlogcontents';
    this.makeApiCallAndReturnResults(url);
  }

  throwTestException() {
    let url = environment.API_URL + '/mars/testErrorEmail';
    this.makeApiCallAndReturnResults(url);
  }


  makeApiCallAndReturnResults(url) {

    this.httpClient.get(url, {responseType: 'text'})
    .subscribe(
      (response) => {
        this.logContents = response;
      },
      (error) => {
        let errMsg = 'Error :' + error;
        if (url.indexOf('connection')) {
          this.connectionString = errMsg;
        } else {
          this.logContents = errMsg;
        }
      }
    );
  }

}
